import { render } from "./ApprovalStatusPopUp.vue?vue&type=template&id=4e1fbcc3&scoped=true"
import script from "./ApprovalStatusPopUp.js?vue&type=script&lang=js"
export * from "./ApprovalStatusPopUp.js?vue&type=script&lang=js"

import "./ApprovalStatusPopUp.vue?vue&type=style&index=0&id=4e1fbcc3&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e1fbcc3"]])

export default __exports__